import { render, staticRenderFns } from "./WarehouseClientsReport.vue?vue&type=template&id=983958d0&"
import script from "./WarehouseClientsReport.vue?vue&type=script&lang=ts&"
export * from "./WarehouseClientsReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports